import React, { Component } from 'react';


import AddPaneltem from '../common/AddPaneltem';


class ChildrenPanelAddItem extends Component {
  render() {
    const { height, width, label, onClick } = this.props;
    const meta = (
      <div className="meta" style={{ height: 25 }}>
        &nbsp;
      </div>  
    );

    return (
      <AddPaneltem 
        meta={meta}
        height={height}
        width={width}
        label={label}
        header={true}
        onClick={onClick}
      />
    );
  }
}


export default ChildrenPanelAddItem;
